import { AclAction } from 'shared/domains/apollo/generated/types';
/**
 * Holds just the data needed to render mention access badges, with no
 * reference to the editor/plugin that owns it. This is embedded into every
 * comment's nested editor config (see UserMentionsRTC).
 */
export class MentionAccessResolver {
    constructor(isExternal) {
        this.userAclsMap = {};
        this.externalUserIds = new Set();
        this.mentionClassNameCache = new Map();
        this.isExternal = isExternal;
    }
    update(userAclsMap, externalUserIds) {
        this.userAclsMap = userAclsMap;
        this.externalUserIds = new Set(externalUserIds);
        this.mentionClassNameCache.clear();
    }
    getUserActions(userId) {
        if (this.isExternal) {
            return [AclAction.Read];
        }
        return this.userAclsMap[userId] || [];
    }
    hasReadAccess(userId) {
        return this.getUserActions(userId).includes(AclAction.Read);
    }
    isExternalUser(userId) {
        return this.externalUserIds.has(userId);
    }
    getMentionClassName(userId) {
        const cached = this.mentionClassNameCache.get(userId);
        if (cached) {
            return cached;
        }
        const classNames = ['mention'];
        if (this.isExternalUser(userId)) {
            classNames.push('external');
        }
        else if (this.hasReadAccess(userId)) {
            classNames.push('access');
        }
        else {
            classNames.push('no-access');
        }
        const className = classNames.join(' ');
        this.mentionClassNameCache.set(userId, className);
        return className;
    }
}
